import { BadgeVariants } from '~backoffice/app/~shared/components/ui/badge/badge.component';
import { OrganizationStatusLabel } from '~core/models/organization.models';

export const getOrganizationStatusLabelColor = (
  status: OrganizationStatusLabel
): BadgeVariants['variant'] => {
  switch (status) {
    case OrganizationStatusLabel.ACTIVE:
      return 'success';

    case OrganizationStatusLabel.CESSATION:
      return 'inactive';

    case OrganizationStatusLabel.ADMINISTRATIVE_CESSATION:
      return 'neutral';

    case OrganizationStatusLabel.IN_ACTIVITY:
      return 'success';

    default:
      return 'info';
  }
};

export const getOrganizationStatusLabelName = (
  value: OrganizationStatusLabel | undefined | null
): string => {
  if (!value) {
    return 'Aucun';
  }

  switch (value) {
    case OrganizationStatusLabel.ACTIVE:
      return 'Actif';

    case OrganizationStatusLabel.CESSATION:
      return 'Cessation';

    case OrganizationStatusLabel.ADMINISTRATIVE_CESSATION:
      return 'Cessation Administrative';

    case OrganizationStatusLabel.IN_ACTIVITY:
      return 'En activité';

    default:
      return value;
  }
};
